import React, { useState } from "react";
import { FaSearch, FaTrash } from "react-icons/fa";
import './add-extras.css';

function FormInventory() {
    const simulatedFlights = [
        {
            flight: "AM0123/25MAY",
            year: "2025",
        },
        {
            flight: "AM0456/13APR",
            year: "2025",
        },
        {
            flight: "AM0089/09JUN",
            year: "2024",
        }
    ];

    const [form, setForm] = useState({
        awb: '',
        flight_arrive: '',
        flight_exit: '',
        origin: '',
        destination: '',
        etd: '',
        pieces: '',
        weight: '',
        total_pieces: '',
        total_weight: '',
        volume: '',
        description: ''
    });
    const [yearArrive, setYearArrive] = useState(new Date().getFullYear().toString());
    const [yearExit, setYearExit] = useState(new Date().getFullYear().toString());
    const [errors, setErrors] = useState([]);
    const [showError, setShowError] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;
        if (name === "awb") {
            newValue = newValue.replace(/\D/g, "");
            if (newValue.length > 3 && newValue[3] !== "-") {
                newValue = newValue.slice(0, 3) + "-" + newValue.slice(3);
            }
        }

        setForm(prev => ({ ...prev, [name]: newValue  }));
    };

    const onlyAllowNumbers = (e) => {
        let value = e.target.value;
        value = value.replace(/[^0-9.]/g, '');

        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts[1];
        }

        e.target.value = value;
    };

    const generateYears = () => {
        const startYear = 2019;
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        const years = [];

        for (let y = startYear; y <= nextYear; y++) {
            years.push(y.toString());
        }

        return years;
    };

    const handleSearchMaster = () => {
        alert('Buscar');
    }
    
    const handleDeleteMaster = () => {
        alert('Borrar');
    }

    const handleSave = () => {
        const allFilled = Object.values(form).every(value => value !== "");
        const validationErrors = [];  // Arreglo para guardar los errores

        const pieces = parseFloat(form.pieces);
        const totalPieces = parseFloat(form.total_pieces);
        const weight = parseFloat(form.weight);
        const totalWeight = parseFloat(form.total_weight);
        const flightArrive = form.flight_arrive;
        const flightExit = form.flight_exit;

        if (!allFilled) {
            validationErrors.push("Por favor llenar el formulario por completo");
        }

        // Validaciones
        if (!isNaN(pieces) && !isNaN(totalPieces) && pieces > totalPieces) {
            validationErrors.push("Las piezas no pueden ser mayores que las piezas totales");
        }

        if (!isNaN(weight) && !isNaN(totalWeight) && weight > totalWeight) {
            validationErrors.push("El peso no puede ser mayor que el peso total");
        }

        if (!isNaN(pieces) && pieces < 0) {
            validationErrors.push("El resultado de las piezas no puede ser menor a 0");
        }

        if (!isNaN(weight) && weight < 0) {
            validationErrors.push("El resultado del peso no puede ser menor a 0");
        }

        if(!(simulatedFlights.find(flights => flights.flight === flightArrive && flights.year === yearArrive))) {
            validationErrors.push("El vuelo de llegada no existe");
        }

        if(!(simulatedFlights.find(flights => flights.flight === flightExit && flights.year === yearExit))) {
            validationErrors.push("El vuelo de salida no existe");
        }

        // Mostrar errores
        if (validationErrors.length > 0) {
            setErrors(validationErrors);
            setShowError(true);
        } else {
            setErrors([]);
            setShowError(false);
            alert("Formulario guardado correctamente ✅");
            // Simulacion de envio al back
            const dataToSend = {
                awb: form.awb,
                flight_arrive: form.flight_arrive,
                flight_exit: form.flight_exit,
                origin: form.origin,
                destination: form.destination,
                etd: form.etd,
                pieces: form.pieces,
                weight: form.weight,
                total_pieces: form.total_pieces,
                total_weight: form.total_weight,
                volume: form.volume,
                description: form.description,
                year_arrive: yearArrive,
                year_exit: yearExit
            };
            console.log("Datos preparados para backend:", dataToSend);
        }
    }

    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label className="amc-label">Master*</label>
                    <div className="d-flex">
                        <input
                            type="text"
                            className="form-control"
                            name="awb"
                            value={form.awb}
                            onChange={handleChange}
                        />
                        <button className="btn-search-awb" onClick={handleSearchMaster}>
                            <FaSearch />
                        </button>
                        <button className="btn-clean-awb" onClick={handleDeleteMaster}>
                            <FaTrash />
                        </button>
                    </div>
                    <small className="text-muted" style={{fontSize: '0.6rem'}}>
                        Clic en <b><FaSearch /></b> para buscar master existente
                    </small>
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label className="amc-label">Vuelo de llegada*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="flight_arrive"
                        value={form.flight_arrive}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="year_exit_select" class="amc-label">Año llegada*</label>
                    <select 
                        className="form-select" 
                        name="year_arrive_select"
                        id="year_arrive_select"
                        value={yearArrive}
                        onChange={(e) => setYearArrive(e.target.value)}
                    >
                        {generateYears().map((y) => (
                            <option key={y} value={y}>
                                {y}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label className="amc-label">Vuelo de salida*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="flight_exit"
                        value={form.flight_exit}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="year_arrive_select" class="amc-label">Año salida*</label>
                    <select 
                        className="form-select" 
                        name="year_exit_select"
                        id="year_exit_select"
                        value={yearExit}
                        onChange={(e) => setYearExit(e.target.value)}
                    >
                        {generateYears().map((y) => (
                            <option key={y} value={y}>
                                {y}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label className="amc-label">Origen*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="origin"
                        value={form.origin}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="destination" className="amc-label">Destino*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="destination"
                        value={form.destination}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="etd" className="amc-label">ETD*</label>
                    <input
                        type="time"
                        className="form-control"
                        name="etd"
                        value={form.etd}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="pieces" class="amc-label">Piezas*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="pieces"
                        value={form.pieces}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="weight" class="amc-label">Peso*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="weight"
                        value={form.weight}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="total_pieces" class="amc-label">Piezas Totales*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="total_pieces"
                        value={form.total_pieces}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="total_weight" class="amc-label">Peso Total*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="total_weight"
                        value={form.total_weight}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="volume" className="amc-label">Volumen</label>
                    <input
                        type="text"
                        className="form-control"
                        name="volume"
                        value={form.volume}
                        onInput={onlyAllowNumbers}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-12 col-md-2 mb-4 mb-md-0">
                    <label for="description" className="amc-label">Descripción*</label>
                    <input
                        type="text"
                        className="form-control"
                        name="description"
                        value={form.description}
                        onChange={handleChange}
                    />
                </div>
            </div>
            {showError && (
                <div className="alert alert-danger mt-3">
                    Se han encontrado los siguientes errores:
                    <br />
                    <ul>
                        {errors.map((err, i) => (
                            <li key={i}>{err}</li>
                        ))}
                    </ul>
                </div>
            )}
            <div className="row">
                <div className="col mt-4 d-flex justify-content-end">
                    <button className='btnn' onClick={handleSave} >Guardar</button>
                </div>
            </div>
        </div>
    );
}

export default FormInventory;